import { useState } from 'react';

const faqs = [
  { q: '动漫网官网首页如何直达？', a: '收藏本页面网址（https://mangoclick.github.io）即可一键直达动漫网首页。你也可以将动漫网导航页加入浏览器收藏夹，随时快速进入。' },
  { q: '如何快速找到想看的番剧？', a: '使用首页顶部或 Hero 区域的搜索框，输入动漫名即可精准直达。也可以通过动漫分类导航，按题材筛选你感兴趣的作品。' },
  { q: '动漫网的分类有哪些？', a: '动漫网提供热血冒险、校园恋爱、奇幻异界、科幻机甲、悬疑惊悚、治愈日常六大热门分类，直达链接清晰覆盖不同口味。' },
  { q: '收藏动漫网导航页有什么好处？', a: '收藏动漫网导航页就等于把动漫网入口地址握在手里，网址收藏、直达链接、主页导航全都有，想看番直接进，不用再搜来搜去。' },
];

export default function FaqSection() {
  const [open, setOpen] = useState(0);
  return (
    <section className="bg-background-100/70 py-12 md:py-16">
      <div className="mx-auto w-full max-w-3xl px-4 md:px-6">
        <div className="text-center">
          <p className="text-sm font-medium text-primary-600">FAQ</p>
          <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">常见问题</h2>
        </div>
        <div className="mt-6 space-y-3">
          {faqs.map((f, i) => (
            <div key={f.q} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <button
                type="button"
                onClick={() => setOpen(open === i ? -1 : i)}
                aria-expanded={open === i}
                className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
              >
                <span className="font-medium text-foreground-900">{f.q}</span>
                <i className={`${open === i ? 'ri-subtract-line' : 'ri-add-line'} text-foreground-500`} aria-hidden="true" />
              </button>
              {open === i && <p className="px-5 pb-4 text-sm leading-relaxed text-foreground-600">{f.a}</p>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}